import {InsuranceType} from '../sale';
import {Dropdown} from './dropdown';

const INSURANCE_TYPE_OPTIONS_FR: Dropdown<InsuranceType>[] = [
  {name: 'Vie', value: InsuranceType.LIFE},
  {name: 'Handicap', value: InsuranceType.DISABILITY},
  {name: 'Maladie grave', value: InsuranceType.CRITICAL_ILLNESS},
];

const INSURANCE_TYPE_OPTIONS_EN: Dropdown<InsuranceType>[] = [
  {name: 'Life', value: InsuranceType.LIFE},
  {name: 'Disability', value: InsuranceType.DISABILITY},
  {name: 'Critical illness', value: InsuranceType.CRITICAL_ILLNESS},
];

export const INSURANCE_TYPE_OPTIONS = {
  en: INSURANCE_TYPE_OPTIONS_EN,
  fr: INSURANCE_TYPE_OPTIONS_FR,
};
